import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(client)/network/(pages)/(detail)/$companyId/integrations',
)({
  component: () => <Outlet />,
});
